import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import FjInterestsTable from './FjInterestsTable.jsx';

const FjInterestsDetail = ({
  interestedData,
  refetchInterestedData,
  canDeleteInterest,
}) => {
  const { t } = useTranslation();

  return (
    <FjInterestsTable
      interestedData={interestedData}
      refetchInterestedData={refetchInterestedData}
      canDeleteInterest={canDeleteInterest}
    />
  );
};

FjInterestsDetail.propTypes = {
  interestedData: PropTypes.array,
  refetchInterestedData: PropTypes.func,
  canDeleteInterest: PropTypes.bool,
};

export default FjInterestsDetail;
